/**
 *
 * "Modal window for confirming irreversible choices"
 *
 * @file   ConfirmationDialog.js
 * @author Lateral
 * @since  2023
 */
import * as React from 'react'
import { DeckMappDialog } from 'components/DeckMappDialog'

export const ConfirmationDialog = ({ onClose, text, saveButtonProps }) => {
  const handleClose = (action) => {
    if (onClose) {
      onClose(action)
    }
  }
  return (
    <DeckMappDialog
      open
      saveButtonProps={{
        onClick: () => handleClose(true),
        title: 'Continue',
        ...saveButtonProps
      }}
      onCancel={() => handleClose(false)}
      title="Confirm Action">
      {text ?? 'This action cannot be reversed. Are you sure you want to continue?'}
    </DeckMappDialog>
  )
}

export default ConfirmationDialog
